(function () {
  'use strict';

  /* Bail inside the VWO visual editor. VWO loads the site in a cross-origin
     iframe; our DOM relocation + polling mutate the page mid-digest and trigger
     AngularJS "$apply while digest in progress", which blocks saving. The live
     test runs un-framed, so the variation still works there; preview with
     ?aov_force=c if you need to see it. */
  function inVwoEditor() {
    try {
      /* Only the EDITOR must bail — NOT preview/live, where the variation must run.
         The editor loads the site in a cross-origin iframe (or appends vwo_editor).
         Do NOT bail on the vwo.com referrer: VWO preview opens the real site in a
         new tab referred from app.vwo.com, and the variation has to work there. */
      if (/[?&#](vwo_editor|vis_editor)=/i.test(location.href)) return true;
      if (window.top !== window.self) {
        try { void window.top.location.href; } catch (e) { return true; } /* cross-origin parent → editor frame */
      }
    } catch (e) {}
    return false;
  }
  if (inVwoEditor()) return;

  if (window.__AOV_PDP_V3_WIRED__) return;
  window.__AOV_PDP_V3_WIRED__ = true;

  var root = document.querySelector('[data-aov-pdp-v3]');
  if (!root) return;

  /* Editorial copy from the product_page metaobject (aov_content JSON),
     serialized into the [data-aov-config] tag by Liquid. Keys used here:
     gallery_trust, subscription, duration_step, cta_label_onetime,
     cta_label_subscription. Missing keys fall
     back to the launch copy below. */
  var CFG = {};
  try {
    var cfgEl = root.querySelector('[data-aov-config]');
    if (cfgEl) CFG = withVariantCopy(JSON.parse(cfgEl.textContent) || {});
  } catch (e) { CFG = {}; }

  /* Test 7 (aov-pdp-v4 template, docs/test-7-pdp-v4.md): the variant's copy is
     written in its own snippets, never in aov_content, and the bits this script
     reads ride in [data-aov-v4-copy] (snippets/aov-pdp-v4-column.liquid) — overlay
     them. That element only exists on the variant, so control is untouched. */
  function withVariantCopy(cfg) {
    var el = root.querySelector('[data-aov-v4-copy]');
    if (!cfg || !el) return cfg;
    var copy;
    try { copy = JSON.parse(el.textContent) || {}; } catch (e) { return cfg; }
    ['cta_label_onetime', 'cta_label_subscription'].forEach(function (key) {
      if (copy[key] !== undefined) cfg[key] = copy[key];
    });
    return cfg;
  }

  /* QA override, reduced 2026-08-06: since the DOM-diet refactor the standard
     blocks are NOT server-rendered on the aov-pdp template (the buy-button,
     accordion and promo box render natively inside this layout's slots), so
     ?aov_force=a/b can no longer show a working standard layout — removing the
     class would leave a page with no CTA. a/b now only warns; =c stays a no-op
     class re-add for saved QA links. */
  try {
    var qs = new URLSearchParams(window.location.search);
    var f = qs.get('aov_force');
    if (f === 'c') document.documentElement.classList.add('aov-pdp-v3-on');
    else if (f === 'a' || f === 'b') console.warn('[aov] aov_force=a/b is retired: standard blocks are no longer rendered on the aov-pdp template (2026-08-06 refactor).');

    /* Test 6 — "Co jest w środku" actives strip (docs/test-6-aov-actives-strip.md).
       VWO adds `aov-t6-b-on` before render; these params are for QA links only, so
       the flip lands a frame later than the real variation does. */
    var t6 = qs.get('t6_force');
    if (t6 === 'b') document.documentElement.classList.add('aov-t6-b-on');
    else if (t6 === 'a') document.documentElement.classList.remove('aov-t6-b-on');
  } catch (e) {}

  function isActive() { return document.documentElement.classList.contains('aov-pdp-v3-on'); }

  /* relocate() removed 2026-08-06: the buy-button, accordion and promo box are
     rendered by Liquid directly inside [data-aov-cta-slot] / [data-aov-accordion-slot]
     / [data-aov-promo-slot] (captured in sections/main-product.liquid), and the
     duplicate nc-breadcrumbs section is gone from templates/product.aov-pdp.json.
     Promo collapsed-by-default now comes from the block setting in that template. */

  /* Inject the floating trust widget overlaid on the FIRST gallery photo
     (top-left media item), top-right corner. Only on variation B. */
  function injectGalleryTrust() {
    if (!isActive()) return;
    /* Attach to the first media item so the panels sit on the first photo
       from the left — not the whole gallery (which would land on the 2nd tile).
       Desktop grid: .product__media-grid__item; mobile carousel: .embla__slide. */
    var itemSelectors = ['.product__media-grid__item', '.embla-main__slide', '.embla__slide', '.product__media-item'];
    var host = null;
    for (var i = 0; i < itemSelectors.length; i++) {
      var items = document.querySelectorAll(itemSelectors[i]);
      for (var j = 0; j < items.length; j++) {
        if (items[j].offsetWidth > 0 || items[j].offsetHeight > 0) { host = items[j]; break; }
      }
      if (host) break;
    }
    /* Fallback to the gallery container if no item matched. */
    if (!host) {
      var candidates = ['.product__media-grid', '.embla--main', '.embla-gallery', '.product__media-gallery'];
      for (var k = 0; k < candidates.length; k++) {
        var el = document.querySelector(candidates[k]);
        if (el && (el.offsetWidth > 0 || el.offsetHeight > 0)) { host = el; break; }
      }
    }
    if (!host || host.querySelector('.aov-pdp-v3__gallery-trust')) return;
    if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var gallery = host;

    /* Copy from aov_content.gallery_trust; `"gallery_trust": false` disables the widget. */
    if (CFG.gallery_trust === false) return;
    var GT = CFG.gallery_trust || {};
    var gtGrade = GT.grade || '4.9';
    var gtBrand = GT.brand || 'TrustMate';
    var gtCount = GT.count || '3652 <u>opinii</u>';
    var gtBig = GT.big || '120K+';
    var gtBigLabel = GT.big_label || 'zadowolonych klientek<br>w&nbsp;Polsce';
    var widget = document.createElement('div');
    widget.className = 'aov-pdp-v3__gallery-trust';
    var star = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M8 1.2l1.93 4.34 4.73.5-3.55 3.18 1 4.65L8 11.5 3.89 13.87l1-4.65L1.34 6.04l4.73-.5z" fill="currentColor"/></svg>';
    widget.innerHTML =
      '<a class="aov-pdp-v3__gallery-trust-card" href="#opinie" aria-label="Przejdź do opinii klientów">' +
        '<div class="aov-pdp-v3__gallery-trust-grade">' + gtGrade + '</div>' +
        '<div class="aov-pdp-v3__gallery-trust-stars" aria-label="' + gtGrade + ' z 5">' + star + star + star + star + star + '</div>' +
        '<div class="aov-pdp-v3__gallery-trust-brand"><span class="aov-pdp-v3__tm-name">' + gtBrand + '</span></div>' +
        '<div class="aov-pdp-v3__gallery-trust-count">' + gtCount + '</div>' +
      '</a>' +
      '<div class="aov-pdp-v3__gallery-trust-card aov-pdp-v3__gallery-trust-card--count">' +
        '<div class="aov-pdp-v3__gallery-trust-num">' + gtBig + '</div>' +
        '<div class="aov-pdp-v3__gallery-trust-sub">' + gtBigLabel + '</div>' +
      '</div>';
    /* Scroll to the TrustMate reviews section (sections/ekomi-product-rating-v2.liquid,
       #opinie) instead of a hard anchor jump; href stays as no-JS fallback. */
    widget.querySelector('a.aov-pdp-v3__gallery-trust-card').addEventListener('click', function (e) {
      var reviews = document.getElementById('opinie') || document.querySelector('.ekomi-product-rating');
      if (!reviews) return;
      e.preventDefault();
      reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    gallery.appendChild(widget);
  }

  /* Cross-sell "Dodaj" — fetch product handle, resolve first available variant, add to cart.
     Delegated on `root` rather than bound per button: swapEditorial re-renders the
     cross-sell list on every flavor/dose swap, and per-node listeners would die
     with the markup they were attached to. */
  var PROTOKOL_WIRED = false;
  /* Handles added from the list this session — the swapped-in markup renders every
     row as "Dodaj" again, so the in-cart state is re-applied from here. */
  var ADDED = {};

  function markProtokolAdded() {
    root.querySelectorAll('.aov-pdp-v3__protokol-add[data-aov-add]').forEach(function (btn) {
      if (!ADDED[btn.getAttribute('data-aov-add')]) return;
      btn.disabled = true;
      btn.classList.add('aov-pdp-v3__protokol-add--in-cart');
      var l = btn.querySelector('.aov-pdp-v3__protokol-add-label');
      if (l) l.innerHTML = '<span aria-hidden="true">✓</span> W koszyku';
    });
  }

  function wireProtokolAdd() {
    if (PROTOKOL_WIRED) return;
    PROTOKOL_WIRED = true;
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.aov-pdp-v3__protokol-add[data-aov-add]') : null;
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('aov-pdp-v3__protokol-add--in-cart')) return;
      var handle = btn.getAttribute('data-aov-add');
      if (!handle) return;
      var label = btn.querySelector('.aov-pdp-v3__protokol-add-label');
      var originalText = label ? label.textContent : 'DODAJ';
      if (label) label.textContent = 'Dodaję…';
      btn.disabled = true;
      btn.classList.add('aov-pdp-v3__protokol-add--loading');

      fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('product fetch failed'); return r.json(); })
        .then(function (product) {
          var variant = (product.variants || []).find(function (v) { return v.available; }) || product.variants[0];
          if (!variant) throw new Error('no variant');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
          });
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw new Error(err && err.description || 'add failed'); });
          return r.json();
        })
        .then(function () {
          ADDED[handle] = true;
          btn.classList.remove('aov-pdp-v3__protokol-add--loading');
          btn.classList.add('aov-pdp-v3__protokol-add--in-cart');
          if (label) label.innerHTML = '<span aria-hidden="true">✓</span> W koszyku';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.classList.remove('aov-pdp-v3__protokol-add--loading');
          if (label) label.textContent = originalText;
          console.error('[aov-pdp-v3] add to cart failed:', err);
        });
    });
  }

  var BUSY = false;

  /* ===== Subscription copy version switch =====================
     'v1' = subtitle + 4 benefits + "Jak działa subskrypcja?" expandable
     'v2' = detailed "Dlaczego warto / Jak to działa" explainer
     Edit SUB_COPY to switch. Override per-visit with ?sub_copy=v1|v2. */
  var SUB_COPY = 'v1';
  try { var _sc = new URLSearchParams(location.search).get('sub_copy'); if (_sc === 'v1' || _sc === 'v2') SUB_COPY = _sc; } catch (e) {}

  /* Campaign override for the subscription discount benefit: replaces any
     benefit that states the 20% rate (aov_content.subscription.benefits comes
     from each product's metaobject, so this avoids editing every product).
     Urodziny Natalii 5–16.10.2026 — set to '' when the campaign ends; keep it
     in sync with sub_first_order_discount in snippets/nc-product-buy-button. */
  var SUB_CAMPAIGN_BENEFIT = '-30% na pierwsze zamówienie (bez kodu), potem -20% na każdą paczkę';

  /* Read the subscription per-delivery price from the relocated tab. */
  function subPrice() {
    var el = root.querySelector('[data-aov-cta-slot] .purchase-options_tab--subscription .purchase-options_tab-price');
    if (!el) return '126,02 zł';
    var clone = el.cloneNode(true);
    var day = clone.querySelector('.purchase-options_tab-price-day'); if (day) day.remove();
    var t = clone.textContent.replace(/\s+/g, ' ').trim();
    return t || '126,02 zł';
  }

  /* Move the original (bound) gifts trigger into a slot, or fall back to a fresh
     span. The theme binds .aside-right-trigger click handlers once at page load,
     so reusing the original element is what makes the drawer actually open. */
  function placeGiftsTrigger(slot, origTrigger, label) {
    if (!slot) return;
    label = label || 'sprawdź co dokładnie';
    if (origTrigger) {
      origTrigger.textContent = label;
      origTrigger.classList.add('aov-pdp-v3__sub-link');
      slot.replaceWith(origTrigger);
    } else {
      slot.outerHTML = '<span class="purchase-options_info-link aside-right-trigger aov-pdp-v3__sub-link" data-target="subskrypcja" data-tab="Prezenty">' + label + '</span>';
    }
  }

  function buildSubV1(content, list, origTrigger) {
    /* Copy from aov_content.subscription; launch copy as fallback. A benefit
       containing the "{gifts}" token becomes the gifts-drawer link row. */
    var SUB = CFG.subscription || {};
    var subSubtitle = SUB.subtitle || 'Najlepsze efekty daje regularna kuracja.';
    var subBenefits = SUB.benefits || [
      '20% taniej na każdej paczce',
      'Darmowa dostawa. Większa wygoda.',
      'Prezenty i punkty Natu.Club — {gifts}',
      'Pauza lub anulowanie w każdej chwili'
    ];
    if (SUB_CAMPAIGN_BENEFIT) {
      subBenefits = subBenefits.map(function (benefit) {
        return /20\s?%/.test(benefit) ? SUB_CAMPAIGN_BENEFIT : benefit;
      });
    }
    var subGiftsLink = SUB.gifts_link || 'zobacz prezenty w subskrypcji';
    var subHowTitle = SUB.how_title || 'Jak działa subskrypcja?';
    var subHowSteps = SUB.how_steps || [
      'Dziś zamawiasz pierwszą paczkę.',
      'Przed kolejną wysyłką przypomnimy Ci mailem.',
      'Możesz przesunąć, pominąć lub anulować jednym kliknięciem.'
    ];

    /* Subtitle line at the top of the subscription content. */
    if (!content.querySelector('.aov-pdp-v3__sub-subtitle')) {
      var sub = document.createElement('p');
      sub.className = 'aov-pdp-v3__sub-subtitle';
      sub.textContent = subSubtitle;
      var badge = content.querySelector('.purchase-options_badge');
      if (badge && badge.parentNode === content) content.insertBefore(sub, badge.nextSibling);
      else content.insertBefore(sub, content.firstChild);
    }

    /* Benefit list. The "{gifts}" item carries an inline link that opens the
       gifts drawer (reusing the theme's bound trigger element). */
    if (list) {
      list.style.display = '';
      list.innerHTML = '';
      subBenefits.forEach(function (benefit) {
        var li = document.createElement('li');
        var giftsAt = benefit.indexOf('{gifts}');
        if (giftsAt === -1) {
          li.textContent = benefit;
        } else {
          li.appendChild(document.createTextNode(benefit.slice(0, giftsAt)));
          var slot = document.createElement('span'); slot.setAttribute('data-aov-trigger-slot', '');
          li.appendChild(slot);
          var tail = benefit.slice(giftsAt + 7);
          if (tail) li.appendChild(document.createTextNode(tail));
          list.appendChild(li);
          placeGiftsTrigger(slot, origTrigger, subGiftsLink);
          return;
        }
        list.appendChild(li);
      });
    }

    /* "Jak działa subskrypcja?" — expandable explainer placed UNDER the
       frequency dropdown. The steps reveal on click (inline accordion). */
    if (!content.querySelector('.aov-pdp-v3__sub-help')) {
      var help = document.createElement('div');
      help.className = 'aov-pdp-v3__sub-help';
      var stepsHtml = '';
      subHowSteps.forEach(function () {
        stepsHtml += '<li></li>';
      });
      help.innerHTML =
        '<button type="button" class="aov-pdp-v3__sub-help-toggle" aria-expanded="false">' +
          '<span></span>' +
          '<svg class="aov-pdp-v3__sub-help-chev" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 5.25 7 8.75l3.5-3.5"/></svg>' +
        '</button>' +
        '<ol class="aov-pdp-v3__sub-steps" hidden>' + stepsHtml + '</ol>';
      help.querySelector('.aov-pdp-v3__sub-help-toggle span').textContent = subHowTitle;
      help.querySelectorAll('.aov-pdp-v3__sub-steps li').forEach(function (li, i) {
        li.textContent = subHowSteps[i];
      });
      var freq = content.querySelector('.purchase-options_variants--frequency');
      if (freq && freq.parentNode) freq.parentNode.insertBefore(help, freq.nextSibling);
      else content.appendChild(help);
      var btn = help.querySelector('.aov-pdp-v3__sub-help-toggle');
      var steps = help.querySelector('.aov-pdp-v3__sub-steps');
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        steps.hidden = open;
      });
    }
  }

  function buildSubV2(content, list, origTrigger) {
    if (list) list.style.display = 'none';
    var P = subPrice();
    var ic = {
      cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="16" rx="2"/><path d="M3 9.5h18M8 2.5v4M16 2.5v4"/></svg>',
      star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 3 14.6 8.6 20.8 9.3 16.2 13.5 17.5 19.6 12 16.4 6.5 19.6 7.8 13.5 3.2 9.3 9.4 8.6"/></svg>',
      hour: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12M6 21h12M8 3v3.5c0 1.6 4 3 4 5.5s-4 3.9-4 5.5V21M16 3v3.5c0 1.6-4 3-4 5.5"/></svg>',
      clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
      inf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6.5 9a3 3 0 1 0 0 6c2 0 3-2 5.5-3s3.5-3 5.5-3a3 3 0 1 1 0 6c-2 0-3-2-5.5-3S8.5 9 6.5 9z"/></svg>'
    };
    var block = document.createElement('div');
    block.className = 'aov-pdp-v3__subv2';
    block.innerHTML =
      '<div class="aov-pdp-v3__subv2-eyebrow">Dlaczego warto:</div>' +
      '<div class="aov-pdp-v3__subv2-hero">' +
        '<div class="aov-pdp-v3__subv2-hero-amount"><strong>636 zł</strong> oszczędności w skali roku</div>' +
        '<div class="aov-pdp-v3__subv2-hero-sub">30% taniej co miesiąc + darmowa dostawa.</div>' +
      '</div>' +
      '<div class="aov-pdp-v3__subv2-cards">' +
        '<div class="aov-pdp-v3__subv2-card">' +
          '<div class="aov-pdp-v3__subv2-card-head"><span class="aov-pdp-v3__subv2-ic">' + ic.cal + '</span>Zawsze pod ręką</div>' +
          '<p>Nie myślisz o zamówieniu. Paczka czeka przed końcem poprzedniej.</p>' +
        '</div>' +
        '<div class="aov-pdp-v3__subv2-card">' +
          '<div class="aov-pdp-v3__subv2-card-head"><span class="aov-pdp-v3__subv2-ic">' + ic.star + '</span>Prezenty do 500 zł rocznie</div>' +
          '<p>Punkty Natu.Club za każdą paczkę. <span data-aov-trigger-slot></span></p>' +
        '</div>' +
        '<div class="aov-pdp-v3__subv2-card aov-pdp-v3__subv2-card--wide">' +
          '<div class="aov-pdp-v3__subv2-card-head"><span class="aov-pdp-v3__subv2-ic">' + ic.hour + '</span>Pełen efekt potrzebuje regularności</div>' +
          '<p>Skóra odbudowuje się każdego dnia. Nie musisz o tym pamiętać — paczka przychodzi sama.</p>' +
        '</div>' +
      '</div>' +
      '<div class="aov-pdp-v3__subv2-rule"></div>' +
      '<div class="aov-pdp-v3__subv2-eyebrow aov-pdp-v3__subv2-eyebrow--ic"><span class="aov-pdp-v3__subv2-ic">' + ic.clock + '</span>Jak to działa — dokładnie:</div>' +
      '<div class="aov-pdp-v3__subv2-steps">' +
        '<div class="aov-pdp-v3__subv2-step"><span class="aov-pdp-v3__subv2-num">1</span><div class="aov-pdp-v3__subv2-step-body">Dziś — pobieramy <strong>' + P + '</strong>. Pierwsza paczka wysłana w kolejny dzień roboczy.</div></div>' +
        '<div class="aov-pdp-v3__subv2-step"><span class="aov-pdp-v3__subv2-num">2</span><div class="aov-pdp-v3__subv2-step-body">Za 23 dni — wysyłamy mail:' +
          '<div class="aov-pdp-v3__subv2-quote">„Kolejna paczka za 7 dni. Wszystko gra?”</div>' +
          '<div class="aov-pdp-v3__subv2-btns"><span class="aov-pdp-v3__subv2-btn aov-pdp-v3__subv2-btn--primary">Tak, wyślij</span><span class="aov-pdp-v3__subv2-btn">Przesuń o miesiąc</span><span class="aov-pdp-v3__subv2-btn">Anuluj</span></div>' +
        '</div></div>' +
        '<div class="aov-pdp-v3__subv2-step"><span class="aov-pdp-v3__subv2-num">3</span><div class="aov-pdp-v3__subv2-step-body">Za 30 dni — pobieramy <strong>' + P + '</strong>, wysyłamy paczkę. <span class="aov-pdp-v3__sub-muted">Tylko jeśli nie wybierzesz „anuluj” lub „przesuń”.</span></div></div>' +
        '<div class="aov-pdp-v3__subv2-rule aov-pdp-v3__subv2-rule--tight"></div>' +
        '<div class="aov-pdp-v3__subv2-step aov-pdp-v3__subv2-step--always"><span class="aov-pdp-v3__subv2-num aov-pdp-v3__subv2-num--inf">' + ic.inf + '</span><div class="aov-pdp-v3__subv2-step-body"><strong>Zawsze możesz anulować</strong> w panelu lub odpowiadając „STOP” na każdy nasz mail.</div></div>' +
      '</div>';

    var freq = content.querySelector('.purchase-options_variants--frequency');
    if (freq) content.insertBefore(block, freq); else content.appendChild(block);
    placeGiftsTrigger(block.querySelector('[data-aov-trigger-slot]'), origTrigger);
  }

  /* Restyle the relocated subscription content. Idempotent via a done flag. */
  function styleSubscription() {
    var content = root.querySelector('[data-aov-cta-slot] .purchase-options_content--subscription');
    if (!content || content.getAttribute('data-aov-sub-done')) return;
    content.setAttribute('data-aov-sub-done', SUB_COPY);
    var list = content.querySelector('.purchase-options_list');
    /* Preserve the ORIGINAL bound "Prezenty" trigger (theme binds it once at load). */
    var origTrigger = list ? list.querySelector('.aside-right-trigger') : null;
    if (SUB_COPY === 'v2') buildSubV2(content, list, origTrigger);
    else buildSubV1(content, list, origTrigger);
  }

  /* Move the duration chooser (30/60/90 dni) out of its hidden holder and into
     the relocated buy-button as content shown only when the ONE-TIME tab is
     selected. The cards keep their swap listeners (bound at init in
     wireVariantSwap) because moving a DOM node preserves its event handlers.
     Idempotent: once the holder is consumed it's removed, so re-runs no-op. */
  function placeDurationChooser() {
    if (!isActive()) return;
    var holder = root.querySelector('[data-aov-duration-holder]');
    if (!holder) return; /* already placed */
    var slot = root.querySelector('[data-aov-cta-slot]');
    var options = slot && slot.querySelector('.purchase-options');
    if (!options) return; /* buy-button not relocated/hydrated yet — retry next tick */
    var grid = holder.querySelector('.aov-pdp-v3__durations');
    if (!grid) { if (holder.parentNode) holder.parentNode.removeChild(holder); return; }

    var wrap = document.createElement('div');
    wrap.className = 'aov-pdp-v3__onetime-content';
    var head = document.createElement('div');
    head.className = 'aov-pdp-v3__onetime-head';
    var DUR = CFG.duration_step || {};
    head.innerHTML = '<span></span><span class="aov-pdp-v3__onetime-head-note"></span>';
    head.firstChild.textContent = DUR.heading || 'Wybierz długość kuracji';
    head.lastChild.textContent = DUR.note || 'Im dłużej, tym lepszy efekt';
    wrap.appendChild(head);
    wrap.appendChild(grid); /* moves the grid + its wired cards */

    /* Insert directly after the one-time tab (before the subscription tab) so it
       reads as that tab's content — mirroring how the subscription content sits
       beneath the subscription tab. The ~ selector (one-time selected) reveals it. */
    var oneTab = options.querySelector('.purchase-options_tab--onetime');
    if (oneTab && oneTab.parentNode === options) {
      options.insertBefore(wrap, oneTab.nextSibling);
    } else {
      options.appendChild(wrap);
    }
    if (holder.parentNode) holder.parentNode.removeChild(holder);
  }

  /* The CTA label follows the selected purchase mode. Per-product overrides:
     aov_content.cta_label_onetime / cta_label_subscription. (The older single
     `cta_label` key is no longer read — the label is mode-dependent now.) */
  function ctaLabelText() {
    var slot = root.querySelector('[data-aov-cta-slot]');
    var subActive = !!(slot && slot.querySelector('.purchase-options_tab--subscription.purchase-options_tab--selected'));
    return subActive
      ? (CFG.cta_label_subscription || 'Rozpocznij subskrypcję')
      : (CFG.cta_label_onetime || 'Dodaj do koszyka');
  }

  /* Rewrite the first non-empty text node inside `el` — that's the label, and it
     sits next to a price <span> that must survive untouched (both buttons render
     "<label> <price>"). Idempotent: the 500ms applyActive poll calls this. */
  function setLeadingLabel(el, text) {
    if (!el) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && /\S/.test(node.nodeValue)) {
        if (node.nodeValue !== text) node.nodeValue = text;
        return;
      }
    }
    el.insertBefore(document.createTextNode(text), el.firstChild);
  }

  /* Apply that label to BOTH add-to-cart buttons: the in-form submit and the
     theme's pinned bottom bar (which renders its label as "<label> — <price>"). */
  function syncCtaLabels() {
    if (!isActive()) return;
    var label = ctaLabelText();
    var submit = root.querySelector('[data-aov-cta-slot] .product-form__submit');
    if (submit) setLeadingLabel(submit, label + ' ');
    document.querySelectorAll('.product-bottom-bar-button-label').forEach(function (el) {
      setLeadingLabel(el, label + ' — ');
    });
  }

  function applyActive() {
    if (BUSY || !isActive()) return;
    BUSY = true;
    var steps = [placeDurationChooser, captureBase, injectGalleryTrust, styleSubscription, syncCtaLabels, bindSubmitOverride, mirrorBottomBar];
    try { steps.forEach(function (fn) { try { fn(); } catch (e) { console.error('[aov]', fn.name, e); } }); }
    finally { BUSY = false; }
  }

  /* ============================================================
   * In-place variant swap (flavor / dose / duration) — Route A.
   * Keeps the wired buy-button; fetches the target product PAGE,
   * updates the displayed price + gallery, repoints the add-to-cart
   * to the target variant/plan (set on the form at submit), and
   * pushState's the URL.
   * ========================================================== */
  var SWAP = { product: null, sub: null, wired: false, submitBound: false, bodyHTML: null, accordionHTML: null, accordionTrigger: null };
  /* Card selectors per swap kind. The aov-pdp-v4 column (test 7,
     snippets/aov-pdp-v4-column.liquid) renders its own flavor/dose cards with
     the same href / data-aov-key / is-active contract, so they ride the same swap. */
  var CARD_SEL = {
    flavor: '.aov-pdp-v3__flavor-card, .aov4-flavor-card',
    dose: '.aov-pdp-v3__dose-card, .aov4-dose-card',
    duration: '.aov-pdp-v3__duration-card'
  };
  var SWAP_GROUPS = [CARD_SEL.flavor, CARD_SEL.dose, CARD_SEL.duration];

  /* Delegated on `root` (not per card) for two reasons: swapEditorial re-renders
     the wizard on every swap, and placeDurationChooser moves the duration grid
     into the CTA slot — both stay inside `root`, which is never replaced. */
  function wireVariantSwap() {
    if (SWAP.wired) return;
    SWAP.wired = true;
    root.addEventListener('click', function (e) {
      var card = e.target && e.target.closest ? e.target.closest(SWAP_GROUPS.join(',')) : null;
      if (!card || !root.contains(card)) return;
      if (card.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      if (card.classList.contains('is-active')) { e.preventDefault(); return; }
      var href = card.getAttribute('href');
      if (!href || href === '#') return;
      e.preventDefault();
      var kind = card.matches(CARD_SEL.duration) ? 'duration'
               : card.matches(CARD_SEL.dose) ? 'dose'
               : 'flavor';
      markActive(CARD_SEL[kind], card);
      swapTo(href, kind);
    });
  }

  function markActive(sel, card) {
    root.querySelectorAll(sel).forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-checked', 'false'); });
    card.classList.add('is-active'); card.setAttribute('aria-checked', 'true');
  }

  /* Capture the base (30-day) product's variant once, before any swap. The
     subscription is always sold as this product (monthly delivery), regardless
     of the one-time duration the visitor picks. Runs early via applyActive. */
  /* Capture the SUBSCRIPTION target once the buy-button is ready: the 30-day
     (jednopak) product, which is the only one that has selling plans. Updated on
     flavor/dose swaps (see applySwap) so it tracks the chosen flavor's 30-day
     product, but NOT on duration swaps (60/90-day packs have no subscription).
     Guarded on plans.length so it only locks in once the plan dropdown exists. */
  function captureBase() {
    if (SWAP.sub) return;
    var slot = root.querySelector('[data-aov-cta-slot]');
    var form = slot && slot.querySelector('form');
    var idInput = form && form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    var plans = readPlans(slot);
    if (!plans.length) return;
    var subEl = slot.querySelector('.purchase-options_tab--subscription .purchase-options_tab-price');
    /* barHTML: the pinned bottom bar's product row (photo + name) as rendered for
       THIS product — the subscription target until a flavor/dose swap moves it. */
    SWAP.sub = { variantId: idInput.value, plans: plans, priceHTML: subEl ? subEl.innerHTML : null, barHTML: barContentHTML(document) };
  }

  function readPlans(scope) {
    var plans = [];
    (scope || document).querySelectorAll('.purchase-options_variantSelect.po-native option').forEach(function (o) {
      if (o.value) plans.push({ id: o.value, label: (o.textContent || '').trim() });
    });
    return plans;
  }

  /* Write the right variant id + selling plan onto the form just before the
     theme's ProductForm reads it (capture phase). One-time = the swapped product
     (chosen flavor+dose+długość). Subscription = the 30-day product of the chosen
     flavor/dose (SWAP.sub) — duration never applies to a subscription, and only
     the 30-day pack actually has selling plans. */
  function applyTargetToForm() {
    var slot = root.querySelector('[data-aov-cta-slot]');
    if (!slot) return;
    var form = slot.querySelector('form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var subActive = !!slot.querySelector('.purchase-options_tab--subscription.purchase-options_tab--selected');

    if (subActive) {
      if (!SWAP.sub) return; /* not captured yet → theme handles the base product */
      if (idInput) { idInput.disabled = false; idInput.value = SWAP.sub.variantId; }
      if (planInput) {
        var selEl = slot.querySelector('.purchase-options_variantSelect.po-native');
        var lbl = (selEl && selEl.options[selEl.selectedIndex]) ? selEl.options[selEl.selectedIndex].textContent : '';
        planInput.value = pickPlanFrom(SWAP.sub.plans, lbl);
      }
      return;
    }

    /* One-time: the swapped product (or, if nothing swapped, the theme's base). */
    if (!SWAP.product || !SWAP.product.variantId) return;
    if (idInput) { idInput.disabled = false; idInput.value = SWAP.product.variantId; }
    if (planInput) planInput.value = '';
  }

  /* Map a dropdown interval label to the matching plan id within a given plan set
     (plan ids are product-specific, so subscription resolves against SWAP.sub). */
  function pickPlanFrom(plans, intervalLabel) {
    plans = plans || [];
    if (!plans.length) return '';
    var l = (intervalLabel || '').toLowerCase().replace(/\s+/g, ' ').trim();
    var hit = null;
    if (l) hit = plans.filter(function (p) { return p.label.toLowerCase().indexOf(l) !== -1; })[0];
    if (!hit) hit = plans.filter(function (p) { return /1\s*mies/i.test(p.label); })[0] || plans[0];
    return hit ? hit.id : '';
  }

  function bindSubmitOverride() {
    if (SWAP.submitBound) return;
    SWAP.submitBound = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      var btn = t && t.closest ? t.closest('.product-form__submit') : null;
      if (!btn) return;
      var slot = root.querySelector('[data-aov-cta-slot]');
      if (slot && slot.contains(btn)) applyTargetToForm();
    }, true);
    document.addEventListener('submit', function (e) {
      var slot = root.querySelector('[data-aov-cta-slot]');
      if (slot && e.target && slot.contains(e.target)) applyTargetToForm();
    }, true);
    /* Keep the pinned bottom-bar price in sync after a tab switch / frequency
       change (the theme only updates the in-form button price on those). */
    document.addEventListener('click', function (e) {
      var slot = root.querySelector('[data-aov-cta-slot]');
      if (slot && e.target && e.target.closest && e.target.closest('.purchase-options_tab') && slot.contains(e.target)) {
        setTimeout(function () { refreshCtaPrice(slot); syncBottomBarProduct(); syncCtaLabels(); }, 80);
      }
    }, true);
    document.addEventListener('change', function (e) {
      var slot = root.querySelector('[data-aov-cta-slot]');
      if (slot && e.target && slot.contains(e.target)) setTimeout(function () { refreshCtaPrice(slot); }, 80);
    }, true);
    /* The campaign code landed on / left the cart (nc-campaign-price.js). */
    document.addEventListener('nc-campaign-price:change', function () {
      var slot = root.querySelector('[data-aov-cta-slot]');
      if (slot) refreshCtaPrice(slot);
    });
    /* Note: v2's "swap back to 30-day on subscription select" is intentionally
       omitted here — długość kuracji is a visible wizard step, so resetting it
       on tab-switch would be confusing. Subscription is still locked to the
       30-day base at the form/price level (see applyTargetToForm + applySwap). */
  }

  function swapTo(url, kind) {
    /* Normalize to a same-origin relative path (cards may use absolute shop.natu.care URLs). */
    url = url.replace(/^https?:\/\/[^/]+/, '');
    /* Already on this product (e.g. picking the base flavor) → nothing to fetch;
       the card was already marked active and the wizard advances on its own. */
    if (url.split('?')[0] === location.pathname) return;
    /* Carry the season QA override onto the fetched page. Which of aov_content /
       aov_content_b renders is resolved server-side per request (snippets/nc-season),
       so without this a page being proofed with ?season=b would swap in season A
       copy — and pushState would drop the override from the URL. */
    try {
      var season = new URLSearchParams(location.search).get('season');
      if (season === 'a' || season === 'b') url += (url.indexOf('?') === -1 ? '?' : '&') + 'season=' + season;
      /* Same for the alternate template a VWO split-URL test renders
         (?view=aov-pdp-v4): without it the fetched flavor/dose would come back
         as control markup and pushState would drop the visitor out of the variant.
         It goes FIRST in the query: VWO's variation pattern (…?view=aov-pdp-v4*)
         only recognizes "?view=", and card hrefs can carry Google's _gl linker
         param — after a reload, "?_gl=…&view=" would be redirected once more. */
      var view = new URLSearchParams(location.search).get('view');
      if (view && /^aov-pdp/.test(view)) {
        var q = url.indexOf('?');
        url = (q === -1 ? url : url.slice(0, q)) + '?view=' + encodeURIComponent(view) + (q === -1 ? '' : '&' + url.slice(q + 1));
      }
    } catch (e) {}
    root.setAttribute('data-aov-swapping', '1');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('fetch ' + r.status); return r.text(); })
      .then(function (html) { applySwap(new DOMParser().parseFromString(html, 'text/html'), url, kind); })
      .catch(function (err) { console.error('[aov swap] fallback to nav', err); window.location.href = url; })
      .finally(function () { root.removeAttribute('data-aov-swapping'); });
  }

  function applySwap(doc, url, kind) {
    var info = doc.querySelector('.product__info-container');
    if (!info) { window.location.href = url; return; }
    var idInput = info.querySelector('input[name="id"]');
    var oneTimeEl = info.querySelector('.purchase-options_tab--onetime .purchase-options_tab-price');
    var subEl = info.querySelector('.purchase-options_tab--subscription .purchase-options_tab-price');
    var plans = readPlans(info);
    SWAP.product = { url: url, variantId: idInput ? idInput.value : null, plans: plans, barHTML: barContentHTML(doc) };

    /* The subscription target = the 30-day pack of the chosen flavor/dose. Update
       it on flavor/dose swaps only; a DURATION swap (30→60→90) must NOT touch the
       subscription — those packs have their own plans, but subscription always
       stays the 30-day. (Flavor/dose cards land on 30-day products.) */
    var hasPlans = plans.length > 0;
    var updateSub = kind !== 'duration' && hasPlans;
    if (updateSub) SWAP.sub = { variantId: SWAP.product.variantId, plans: plans, priceHTML: subEl ? subEl.innerHTML : (SWAP.sub && SWAP.sub.priceHTML), barHTML: SWAP.product.barHTML || (SWAP.sub && SWAP.sub.barHTML), url: url };

    var slot = root.querySelector('[data-aov-cta-slot]');
    if (slot) {
      copyTabPrice(slot, oneTimeEl, '.purchase-options_tab--onetime .purchase-options_tab-price');
      /* Subscription price: update from the swapped product only on flavor/dose
         swaps; otherwise restore the retained 30-day price (so a 60/90-day pack
         leaves the subscription price untouched). */
      if (updateSub && subEl) {
        copyTabPrice(slot, subEl, '.purchase-options_tab--subscription .purchase-options_tab-price');
        /* The label follows the price: dwupaki sell the subscription with no
           discount, so their tab label differs from the 30-day pack's. */
        var subLabel = info.querySelector('.purchase-options_tab--subscription .purchase-options_tab-label');
        var liveLabel = slot.querySelector('.purchase-options_tab--subscription .purchase-options_tab-label');
        if (subLabel && liveLabel) liveLabel.innerHTML = subLabel.innerHTML;
      } else if (SWAP.sub && SWAP.sub.priceHTML) {
        var liveSub = slot.querySelector('.purchase-options_tab--subscription .purchase-options_tab-price');
        if (liveSub) liveSub.innerHTML = SWAP.sub.priceHTML;
      }
      /* Re-strike the one-time price for the swapped-in product (or drop the
         strike when the campaign code doesn't cover it). */
      if (window.ncCampaignPrice) window.ncCampaignPrice.refresh();
      refreshCtaPrice(slot);
    }
    swapOmnibus(doc, SWAP.product.variantId);

    syncBottomBarProduct();
    /* Editorial first: it re-reads [data-aov-config], which injectGalleryTrust
       (called from swapGallery) and syncCtaLabels read. */
    swapEditorial(doc, kind);
    swapGallery(doc);
    swapBody(doc, kind);
    swapAccordion(doc, kind);
    updateNeighbors(info);
    wizSyncChips();
    /* The swapped-in editorial (protokół) arrives with Liquid's campaign price. */
    if (window.ncCampaignPrice) window.ncCampaignPrice.refresh();
    try { history.pushState({ aov: 1 }, '', url); } catch (e) {}
    /* Re-run the idempotent placement/styling steps over the new markup. */
    applyActive();
  }

  function copyTabPrice(slot, fetchedEl, liveSel) {
    if (!fetchedEl) return;
    var live = slot.querySelector(liveSel);
    if (!live) return;
    live.innerHTML = fetchedEl.innerHTML;
    if (fetchedEl.dataset.price) live.setAttribute('data-price', fetchedEl.dataset.price);
    /* nc-campaign-price.js prices the one-time tab from these (data-nc-plain & co.
       only while Liquid drew the campaign promo — a product without it must not
       keep the previous one's). */
    ['data-nc-otp', 'data-nc-handle', 'data-nc-campaign', 'data-nc-campaign-pct', 'data-nc-plain'].forEach(function (name) {
      if (fetchedEl.hasAttribute(name)) live.setAttribute(name, fetchedEl.getAttribute(name));
      else live.removeAttribute(name);
    });
  }

  /* OMNIBUS line belongs to the product, not the page: replace the per-variant
     templates with the fetched product's and fill the line from its variant.
     (price-omnibus.js only fills it on first load / variant:change.) */
  function swapOmnibus(doc, variantId) {
    var live = root.querySelector('[data-omnibus]');
    if (!live) return;
    var fetched = doc.querySelector('[data-omnibus]');
    live.innerHTML = fetched ? fetched.innerHTML : '';
    var tpl = variantId && live.querySelector('script[id$="-' + variantId + '"]');
    var list = live.querySelector('.product-omnibus-list');
    if (list) list.innerHTML = tpl ? tpl.textContent : '';
  }

  /* Mirror the selected tab's money into the CTA submit button price. */
  function refreshCtaPrice(slot) {
    var activePrice = slot.querySelector('.purchase-options_tab--selected .purchase-options_tab-price');
    if (!activePrice) return;
    var clone = activePrice.cloneNode(true);
    var day = clone.querySelector('.purchase-options_tab-price-day'); if (day) day.remove();
    /* nc-campaign-price.js strikes the regular price through in the one-time tab;
       the CTA charges the price after the code. */
    var was = clone.querySelector('.nc-campaign-was'); if (was) was.remove();
    var money = clone.textContent.replace(/\s+/g, ' ').trim();
    slot.querySelectorAll('.product-form__submit-submitSpan .price bdi').forEach(function (b) { b.textContent = money; });
    setBottomBarPrice(money);
  }

  /* Mirror the active price onto the theme's pinned bottom-bar CTA. Its click
     already triggers the real submit (correct product) — only the label is static. */
  function setBottomBarPrice(money) {
    if (!money) return;
    /* Replace the whole rendered price block with the clean current price, so we
       don't end up with a duplicated compare-at + sale + "-30%" badge. */
    document.querySelectorAll('.product-bottom-bar-button-price').forEach(function (el) {
      el.textContent = money;
    });
  }

  /* The bottom bar's product row (photo + name) as rendered server-side in a given
     document — the page itself, or a product page fetched for an in-place swap. */
  function barContentHTML(doc) {
    var el = (doc || document).querySelector('.product-bottom-bar-content');
    return el ? el.innerHTML : null;
  }

  /* Mirror the product the CTA will actually add onto the pinned bottom bar. The
     bar is rendered for the page's ORIGINAL product, so after a swap its photo and
     name would otherwise be stale. Which product that is depends on the tab:
     one-time = the swapped product, subscription = the 30-day pack (SWAP.sub),
     which duration swaps deliberately leave alone. */
  function syncBottomBarProduct() {
    var slot = root.querySelector('[data-aov-cta-slot]');
    var subActive = !!(slot && slot.querySelector('.purchase-options_tab--subscription.purchase-options_tab--selected'));
    var target = subActive ? SWAP.sub : SWAP.product;
    var html = target && target.barHTML;
    if (!html) return;
    document.querySelectorAll('.product-bottom-bar-content').forEach(function (live) {
      if (live.innerHTML !== html) live.innerHTML = html;
    });
  }

  /* Read the live in-form CTA price and push it to the bottom bar — used after a
     tab switch / frequency change, which the theme updates on the in-form button only. */
  function mirrorBottomBar() {
    var slot = root.querySelector('[data-aov-cta-slot]');
    var src = slot && slot.querySelector('.product-form__submit-submitSpan .price bdi');
    if (src) setBottomBarPrice((src.textContent || '').replace(/\s+/g, ' ').trim());
  }

  function swapGallery(doc) {
    ['.product__media-grid', '.embla--main', '.embla-gallery'].forEach(function (sel) {
      var liveEl = document.querySelector(sel);
      var newEl = doc.querySelector(sel);
      if (liveEl && newEl && (liveEl.offsetWidth > 0 || liveEl.offsetHeight > 0)) {
        liveEl.innerHTML = newEl.innerHTML;
      }
    });
    injectGalleryTrust();
    /* Hook for add-ons that decorate the gallery (e.g. the test-5 hero swap):
       the innerHTML replace above wiped any decoration, let them re-apply. */
    try { document.dispatchEvent(new CustomEvent('aov:gallery-swapped')); } catch (e) {}
  }

  /* Swap the editorial body — the body_json blocks nc-body-v4 renders below the
     fold — to the fetched product's copy, so a 5000→10000 mg or flavor change
     shows that product's own content. Duration packs (30/60/90) share their
     flavor/dose's copy, so duration swaps leave the body alone. The innerHTML
     replace kills every listener inside (slick sliders, ingredient expand,
     YouTube popup) — nc-body-v4.js re-runs its inits on nc:body-reinit; the
     swapped-in HTML is raw server markup, so sliders re-slick cleanly. A target
     with no rendered body (no .nc-body-v3 or empty) keeps the current copy
     rather than blanking the page. */
  function swapBody(doc, kind) {
    if (kind === 'duration') return;
    var live = document.querySelector('.nc-body-v3');
    var fresh = doc.querySelector('.nc-body-v3');
    if (!live || !fresh || !fresh.children.length) return;
    var html = fresh.innerHTML;
    /* Compare against the last swapped-in SOURCE html, not the live DOM — slick
       rewrites the live markup, so live.innerHTML never matches server output. */
    if (html === SWAP.bodyHTML) return;
    live.innerHTML = html;
    SWAP.bodyHTML = html;
    try { document.dispatchEvent(new CustomEvent('nc:body-reinit')); } catch (e) {}
  }

  /* Swap the "Dodatkowe informacje" accordion (per-product
     product_accordion_items metafield, rendered in [data-aov-accordion-slot])
     along with the body — same flavor/dose-only rule and same keep-if-missing
     policy. Two listener sets die with the innerHTML replace:
     nc-product-accordion.js re-binds its <details> handlers on
     nc:accordion-reinit, and the "Jak działa subskrypcja?" drawer span is
     handled by KEEPING the page's original theme-bound .aside-right-trigger
     element and re-inserting it over the fetched (unbound) one — the theme
     binds those clicks once at load, same trick as placeGiftsTrigger. */
  function swapAccordion(doc, kind) {
    if (kind === 'duration') return;
    var live = document.querySelector('.nc-product-accordion');
    var fresh = doc.querySelector('.nc-product-accordion');
    if (!live || !fresh || !fresh.children.length) return;
    var html = fresh.innerHTML;
    if (html === SWAP.accordionHTML) return;
    if (!SWAP.accordionTrigger) SWAP.accordionTrigger = live.querySelector('.aside-right-trigger');
    live.innerHTML = html;
    SWAP.accordionHTML = html;
    var freshTrigger = live.querySelector('.aside-right-trigger');
    if (freshTrigger && SWAP.accordionTrigger) {
      SWAP.accordionTrigger.textContent = freshTrigger.textContent;
      freshTrigger.replaceWith(SWAP.accordionTrigger);
    } else if (freshTrigger) {
      /* This product rendered no trigger at load (blocked_ids) — forward clicks
         to any theme-bound trigger for the same drawer (buy panel has one). */
      var proxy = document.querySelector('.aside-right-trigger[data-target="' + (freshTrigger.dataset.target || 'subskrypcja') + '"]:not(.nc-product-accordion_heading)');
      if (proxy) freshTrigger.addEventListener('click', function () { proxy.click(); });
    }
    try { document.dispatchEvent(new CustomEvent('nc:accordion-reinit')); } catch (e) {}
  }

  /* ============================================================
   * Editorial swap — repaint the whole aov_content column.
   * ==========================================================
   * Everything the visitor reads on this page (hero, actives strip, timeline,
   * wizard copy, trust grid, cross-sell, section titles, the [data-aov-config]
   * JSON) is server-rendered from the product's own aov_content / aov_content_b.
   * Before this, a flavor swap repainted only the gallery, the prices and the
   * below-the-fold body — the copy above kept describing the flavor the visitor
   * landed on. Now the fetched product's whole column replaces it.
   * Duration packs (30/60/90) share their flavor/dose's copy, so duration swaps
   * leave it alone, exactly like swapBody/swapAccordion.
   *
   * Three blocks are NOT re-created, because the theme binds their handlers once
   * at page load and a fresh copy would be dead markup:
   *   [data-aov-promo-slot]  — the promo box IS per-product (a flavour can be
   *                            excluded from the campaign), so its content is
   *                            replaced and re-bound by wirePromoFallback.
   *   [data-aov-buy]         — holds [data-aov-cta-slot]: the <product-form>, the
   *                            JS-built subscription copy, and the duration grid
   *                            placeDurationChooser moved in. Only its editorial
   *                            fields are copied over.
   *   .aov-pdp-v3__addinfo   — holds [data-aov-accordion-slot]; swapAccordion
   *                            updates it and keeps the theme-bound drawer trigger.
   * Every listener inside the replaced markup dies with it — that is why the card,
   * wizard and cross-sell handlers are delegated on `root`, which survives.
   */
  var KEEP_BLOCKS = [
    { match: '[data-aov-promo-slot]', inner: true },
    { match: '[data-aov-buy]', copy: ['.aov-pdp-v3__section-title', '.aov-pdp-v3__cta-footnote'] },
    { match: '.aov-pdp-v3__addinfo', copy: ['.aov-pdp-v3__addinfo-title'] }
  ];

  function keepSpecFor(el) {
    for (var i = 0; i < KEEP_BLOCKS.length; i++) {
      if (el.matches && el.matches(KEEP_BLOCKS[i].match)) return KEEP_BLOCKS[i];
    }
    return null;
  }

  /* Split a rendered column into the runs of editorial blocks between the keep
     anchors. Both renders come from the same snippet, so the anchors appear in
     the same order and the runs line up 1:1 — which lets each run be replaced
     wholesale without ever moving or re-creating a bound node. */
  function segmentBlocks(parent) {
    var out = [], nodes = [];
    Array.prototype.forEach.call(parent.children, function (el) {
      var keep = keepSpecFor(el);
      if (keep) { out.push({ nodes: nodes, anchor: el, keep: keep }); nodes = []; }
      else nodes.push(el);
    });
    out.push({ nodes: nodes, anchor: null, keep: null });
    return out;
  }

  /* Refresh the editorial fields inside a kept block (its bound descendants stay). */
  function copyFields(liveEl, freshEl, sels) {
    (sels || []).forEach(function (sel) {
      var a = liveEl.querySelector(sel), b = freshEl.querySelector(sel);
      if (a && b && a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
    });
  }

  /* Replace the promo slot's content and mark the box as ours to handle: the theme
     binds .promo-box__toggle / .promo-box__item once at DOMContentLoaded, so a
     swapped-in box needs wirePromoFallback below.
     Compared against the last SERVER html (PROMO.html), not the live DOM: the
     toggle writes data-expanded into the live markup, and an expanded box must not
     count as "the promo changed" — that would collapse it and drop the theme's
     own listeners for nothing. */
  function replaceSlotInner(liveEl, freshEl) {
    var html = freshEl.innerHTML;
    if (PROMO.html !== null && html === PROMO.html) return;
    PROMO.html = html;
    liveEl.innerHTML = html;
    liveEl.querySelectorAll('.promo-box').forEach(function (b) { b.setAttribute('data-aov-rebound', ''); });
  }

  function reconcileBlocks(live, fresh) {
    var L = segmentBlocks(live), F = segmentBlocks(fresh);
    /* A structure we don't recognise (a block set that differs between the two
       renders) → leave the page alone rather than half-rewrite it. */
    if (L.length !== F.length) return false;
    for (var i = 0; i < L.length; i++) {
      if (!L[i].anchor !== !F[i].anchor) return false;
      if (L[i].anchor && L[i].keep.match !== F[i].keep.match) return false;
    }
    for (var j = 0; j < L.length; j++) {
      var before = L[j].anchor; /* null on the trailing run → append */
      L[j].nodes.forEach(function (n) { live.removeChild(n); });
      F[j].nodes.forEach(function (n) { live.insertBefore(document.importNode(n, true), before); });
      if (!L[j].anchor) continue;
      if (L[j].keep.inner) replaceSlotInner(L[j].anchor, F[j].anchor);
      else copyFields(L[j].anchor, F[j].anchor, L[j].keep.copy);
    }
    return true;
  }

  /* Delegated stand-in for the theme's promo-box handlers, active only on boxes
     this script swapped in (data-aov-rebound) — the box rendered at page load
     keeps the theme's own listeners and must not fire twice. */
  var PROMO = { wired: false, html: null };
  function wirePromoFallback() {
    if (PROMO.wired) return;
    PROMO.wired = true;
    /* The promo as the server rendered it for THIS product, captured before any
       interaction can change it — the baseline replaceSlotInner compares against. */
    var slot = root.querySelector('[data-aov-promo-slot]');
    if (slot) PROMO.html = slot.innerHTML;
    root.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var box = e.target.closest('.promo-box[data-aov-rebound]');
      if (!box) return;
      if (e.target.closest('.promo-box__toggle')) {
        var expanded = box.getAttribute('data-expanded') === 'true';
        box.setAttribute('data-expanded', String(!expanded));
        var txt = box.querySelector('.promo-box__toggle-text');
        if (txt) txt.textContent = expanded ? 'Zobacz szczegóły' : 'Zwiń';
        return;
      }
      var item = e.target.closest('.promo-box__item:not(.promo-box__item--link)');
      var code = item && item.querySelector('.promo-box__code');
      if (!code || code.getAttribute('data-aov-copying')) return;
      var text = (code.textContent || '').trim();
      if (!text) return;
      code.setAttribute('data-aov-copying', '1');
      copyToClipboard(text);
      code.textContent = 'skopiowany';
      setTimeout(function () { code.textContent = text; code.removeAttribute('data-aov-copying'); }, 1000);
    });
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(function () {});
      return;
    }
    var ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* Re-read [data-aov-config] (it rides along in the replaced markup) and re-apply
     the parts of the page it drives from OUTSIDE that markup. CTA labels follow on
     their own via syncCtaLabels in applyActive. */
  function refreshConfig(prev) {
    var cfgEl = root.querySelector('[data-aov-config]');
    if (cfgEl) {
      try { CFG = withVariantCopy(JSON.parse(cfgEl.textContent) || {}); } catch (e) {}
    }
    /* The trust widget lives on the gallery, which swapGallery rebuilds right
       after this — drop a stale one so it is re-injected with the new copy. */
    if (JSON.stringify(CFG.gallery_trust) !== JSON.stringify(prev.gallery_trust)) {
      var w = document.querySelector('.aov-pdp-v3__gallery-trust');
      if (w && w.parentNode) w.parentNode.removeChild(w);
    }
    if (JSON.stringify(CFG.subscription) !== JSON.stringify(prev.subscription)) resetSubscriptionCopy();

    var DUR = CFG.duration_step || {};
    var head = root.querySelector('.aov-pdp-v3__onetime-head');
    if (head && head.firstChild && head.lastChild) {
      head.firstChild.textContent = DUR.heading || 'Wybierz długość kuracji';
      head.lastChild.textContent = DUR.note || 'Im dłużej, tym lepszy efekt';
    }
  }

  /* Drop the JS-built subscription copy so styleSubscription rebuilds it from the
     new CFG. The theme-bound "Prezenty" trigger is parked back in the benefits
     list first: the v2 layout builds it into a block we're about to delete, and it
     cannot be re-created (the theme binds those clicks once at load). */
  function resetSubscriptionCopy() {
    var content = root.querySelector('[data-aov-cta-slot] .purchase-options_content--subscription');
    if (!content) return;
    var list = content.querySelector('.purchase-options_list');
    var trig = content.querySelector('.aside-right-trigger');
    if (trig && list && !list.contains(trig)) list.appendChild(trig);
    ['.aov-pdp-v3__sub-subtitle', '.aov-pdp-v3__sub-help', '.aov-pdp-v3__subv2'].forEach(function (sel) {
      content.querySelectorAll(sel).forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    });
    content.removeAttribute('data-aov-sub-done');
  }

  /* The wizard's step states live in the markup the swap replaces, and the fetched
     page always comes back at its server defaults (Smak active, Dawka pending), so
     carry the visitor's progress across. Chip VALUES are re-read later
     (wizSyncChips, after updateNeighbors) so they name what was just picked. */
  function wizSnapshot() {
    var snap = { state: {}, touched: {} };
    WIZ.order.forEach(function (n) { snap.state[n] = wizState(n); });
    snap.touched.flavor = !root.querySelector('.aov-pdp-v3__flavors[data-aov-flavors-untouched]');
    snap.touched.dose = !root.querySelector('.aov-pdp-v3__doses[data-aov-doses-untouched]');
    return snap;
  }

  function wizRestore(snap) {
    WIZ.order.forEach(function (n) { if (snap.state[n]) wizSet(n, snap.state[n]); });
    if (snap.touched.flavor) {
      var f = root.querySelector('.aov-pdp-v3__flavors');
      if (f) f.removeAttribute('data-aov-flavors-untouched');
    }
    if (snap.touched.dose) {
      var d = root.querySelector('.aov-pdp-v3__doses');
      if (d) d.removeAttribute('data-aov-doses-untouched');
    }
    wizRevealBuy();
  }

  function wizSyncChips() {
    WIZ.order.forEach(function (n) { if (wizState(n) === 'completed') wizSetChip(n); });
    wizUpdateProgress();
  }

  function swapEditorial(doc, kind) {
    if (kind === 'duration') return;
    var fresh = doc.querySelector('[data-aov-pdp-v3]');
    if (!fresh || !fresh.children.length) return;

    var snap = wizSnapshot();
    var prevCfg = { gallery_trust: CFG.gallery_trust, subscription: CFG.subscription };

    /* placeDurationChooser has already moved the live duration grid into the CTA
       slot and removed its holder, so the fetched holder must not be rendered as
       well — refresh the moved grid's cards from it instead, then drop it. */
    var freshHolder = fresh.querySelector('[data-aov-duration-holder]');
    if (freshHolder && !root.querySelector('[data-aov-duration-holder]')) {
      var liveGrid = root.querySelector('.aov-pdp-v3__durations');
      var freshGrid = freshHolder.querySelector('.aov-pdp-v3__durations');
      if (liveGrid && freshGrid && freshGrid.children.length) liveGrid.innerHTML = freshGrid.innerHTML;
      freshHolder.parentNode.removeChild(freshHolder);
    }

    if (!reconcileBlocks(root, fresh)) {
      console.warn('[aov swap] editorial block set differs — keeping the current copy');
      return;
    }
    refreshConfig(prevCfg);
    markProtokolAdded();
    wizRestore(snap);
  }

  /* Map a variant-button label to the same key used on my step cards. */
  function flavorKey(l) {
    l = (l || '').toLowerCase();
    if (/truskaw|rabar/.test(l)) return 'strawberry';
    if (/jeżyn|jezyn/.test(l)) return 'blackberry';
    if (/mix/.test(l)) return 'mix';
    if (/bezsmak|natural/.test(l)) return 'neutral';
    return 'mango';
  }
  function doseKey(l) { var s = (l || '').replace(/\s+/g, ''); if (/10000/.test(s)) return '10000'; if (/5000/.test(s)) return '5000'; return null; }
  function durationKey(l) {
    l = (l || '').toLowerCase();
    if (/jednopak|1\s*pak/.test(l)) return '30';
    if (/dwupak|2\s*pak/.test(l)) return '60';
    if (/trzypak|3\s*pak/.test(l)) return '90';
    /* Promo packs ("Sale for Certain Flavors") — Minipak before Tester, matching
       the Liquid precedence. Kept in sync so the 7/3 cards re-point (or gracefully
       disable) after a flavor/dose swap instead of being force-disabled. */
    if (/minipak/.test(l)) return '7';
    if (/tester/.test(l)) return '3';
    return null;
  }

  /* After a swap, repoint the OTHER step groups to the new product's neighbor
     links (from its metafield-rendered variant rows) so flavor×dose×duration
     combinations resolve correctly. A dimension the current product doesn't
     offer (e.g. 10000 mg exists only for some flavors) is gracefully disabled
     rather than wrongly jumping to a different flavor. */
  function updateNeighbors(info) {
    var GROUPS = [
      { sel: CARD_SEL.flavor, key: flavorKey, head: 'smak', def: null },
      { sel: CARD_SEL.dose, key: doseKey, head: 'kolagenu', def: '5000' },
      { sel: CARD_SEL.duration, key: durationKey, head: 'ilość', def: null }
    ];
    var maps = {};
    info.querySelectorAll('.purchase-options_variant').forEach(function (row) {
      var hEl = row.querySelector('.purchase-options_variantHeading');
      var h = (hEl ? hEl.textContent : '').toLowerCase();
      var g = h.indexOf('smak') !== -1 ? GROUPS[0] : (h.indexOf('kolagenu') !== -1 ? GROUPS[1] : (h.indexOf('ilość') !== -1 ? GROUPS[2] : null));
      if (!g) return;
      var map = {};
      row.querySelectorAll('.purchase-options_variantButton').forEach(function (btn) {
        var k = g.key((btn.textContent || '').trim());
        if (k && !map[k]) map[k] = { href: btn.getAttribute('href'), active: btn.classList.contains('purchase-options_variantButton-active') };
      });
      maps[g.sel] = map;
    });
    GROUPS.forEach(function (g) {
      var map = maps[g.sel];
      root.querySelectorAll(g.sel).forEach(function (card) {
        var k = card.getAttribute('data-aov-key');
        card.classList.remove('is-active', 'aov-pdp-v3__card--na');
        card.setAttribute('aria-checked', 'false');
        card.removeAttribute('aria-disabled');
        var nb = map ? map[k] : null;
        if (nb) {
          if (nb.active) { card.classList.add('is-active'); card.setAttribute('aria-checked', 'true'); card.removeAttribute('href'); }
          else if (nb.href) { card.setAttribute('href', nb.href); }
        } else if (!map && g.def && k === g.def) {
          /* Dimension absent for this product → keep the default option active. */
          card.classList.add('is-active'); card.setAttribute('aria-checked', 'true'); card.removeAttribute('href');
        } else {
          /* Option not offered for this product → disable it. */
          card.removeAttribute('href'); card.setAttribute('aria-disabled', 'true'); card.classList.add('aov-pdp-v3__card--na');
        }
      });
    });
  }

  /* ===== Stepper wizard (v3) — one step at a time: Smak → Dawka → Długość =====
   * Active step shows its panel; completed steps collapse to a chip (with Zmień);
   * pending steps are hidden. The steps are seeded from the landed product at
   * load (wizPrefill), so the wizard normally opens fully answered.
   * Selection still triggers the in-place swap (wireVariantSwap); this layer only
   * drives step state, chip summaries and progress dots. */
  var WIZ = { order: ['flavor', 'dose'], bound: false, prefilled: false };
  var WIZ_CARD = { flavor: '.aov-pdp-v3__flavor-card', dose: '.aov-pdp-v3__dose-card', duration: '.aov-pdp-v3__duration-card' };

  function wizStep(name) { return root.querySelector('.aov-pdp-v3__wstep[data-aov-step="' + name + '"]'); }
  function wizState(name) { var s = wizStep(name); return s ? s.getAttribute('data-state') : null; }
  function wizSet(name, state) { var s = wizStep(name); if (s) s.setAttribute('data-state', state); }

  function wizChipValue(name) {
    var card = root.querySelector(WIZ_CARD[name] + '.is-active');
    if (!card) return '';
    var el = card.querySelector(
      name === 'flavor' ? '.aov-pdp-v3__flavor-label'
      : name === 'dose' ? '.aov-pdp-v3__dose-amount'
      : '.aov-pdp-v3__duration-amount'
    );
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function wizSetChip(name) {
    var s = wizStep(name); if (!s) return;
    var v = s.querySelector('[data-aov-chip-value]');
    if (v) v.textContent = wizChipValue(name) || '—';
  }

  /* The purchase panel is shown from page load and never hidden again — a visitor
     must be able to add to cart at any point, not only after finishing the wizard.
     Kept as a call so a panel that ships with [hidden] still gets revealed. */
  function wizRevealBuy() {
    var buy = root.querySelector('[data-aov-buy]');
    if (buy) buy.removeAttribute('hidden');
  }

  function wizUpdateProgress() {
    var dots = root.querySelectorAll('.aov-pdp-v3__progress-dot');
    var allDone = true;
    for (var i = 0; i < WIZ.order.length; i++) {
      var st = wizState(WIZ.order[i]); var d = dots[i];
      if (st !== 'completed') allDone = false;
      if (!d) continue;
      d.classList.remove('is-active', 'is-done');
      if (st === 'completed') d.classList.add('is-done');
      else if (st === 'active') d.classList.add('is-active');
    }
    if (dots[WIZ.order.length]) {
      dots[WIZ.order.length].classList.remove('is-active', 'is-done');
      if (allDone) dots[WIZ.order.length].classList.add('is-active');
    }
    /* A wizard that opens fully seeded would render a 100%-complete progress bar
       on load, which reads as broken — hide it until a step is reopened (Zmień).
       Visitors who work through the steps themselves keep the bar throughout. */
    var prog = root.querySelector('[data-aov-progress]');
    if (prog) {
      if (WIZ.prefilled && allDone) prog.setAttribute('hidden', '');
      else prog.removeAttribute('hidden');
    }
  }

  /* Seed the wizard from the product the visitor actually landed on. Every product
     page resolves exactly one is-active card per group server-side, so someone
     arriving on the truskawka 5000 mg URL starts with Smak + Dawka answered rather
     than being asked to re-pick what the link already chose — and the chips then
     agree with the always-visible CTA, which adds that exact product.
     A group with no is-active card (data gap) is left alone, so the step-by-step
     flow still works for it. */
  function wizPrefill() {
    WIZ.order.forEach(function (name) {
      if (wizState(name) === 'completed') return;
      if (!root.querySelector(WIZ_CARD[name] + '.is-active')) return;
      /* Drop the "untouched" suppression so the seeded card reads as selected
         when the step is reopened via Zmień. */
      var groupSel = name === 'flavor' ? '.aov-pdp-v3__flavors' : '.aov-pdp-v3__doses';
      var attr = name === 'flavor' ? 'data-aov-flavors-untouched' : 'data-aov-doses-untouched';
      var group = root.querySelector(groupSel);
      if (group) group.removeAttribute(attr);
      wizComplete(name);
    });
    WIZ.prefilled = WIZ.order.every(function (n) { return wizState(n) === 'completed'; });
  }

  /* Reopen a step (Zmień): make it active, keep earlier steps as chips, and RESET
     every LATER step to pending — changing an earlier choice (e.g. flavor) can
     change what's valid downstream (e.g. dose), so those must be re-picked. */
  function wizActivate(name) {
    var idx = WIZ.order.indexOf(name);
    WIZ.order.forEach(function (n, i) {
      if (i === idx) { wizSet(n, 'active'); return; }
      if (i > idx) {
        wizSet(n, 'pending');
        var s = wizStep(n);
        var v = s && s.querySelector('[data-aov-chip-value]');
        if (v) v.textContent = '—';
        /* re-arm the "untouched" suppression so the reset step shows no selection */
        if (n === 'flavor') { var f = root.querySelector('.aov-pdp-v3__flavors'); if (f) f.setAttribute('data-aov-flavors-untouched', ''); }
        if (n === 'dose') { var d = root.querySelector('.aov-pdp-v3__doses'); if (d) d.setAttribute('data-aov-doses-untouched', ''); }
      }
    });
    wizUpdateProgress();
  }

  /* Complete a step and advance to the next one that isn't done yet (if any). */
  function wizComplete(name) {
    wizSet(name, 'completed');
    wizSetChip(name);
    var next = null;
    for (var i = 0; i < WIZ.order.length; i++) {
      if (wizState(WIZ.order[i]) !== 'completed') { next = WIZ.order[i]; break; }
    }
    if (next) wizSet(next, 'active');
    wizUpdateProgress();
  }

  function wireWizard() {
    if (WIZ.bound) return;
    var wiz = root.querySelector('[data-aov-wizard]');
    if (!wiz) return;
    WIZ.bound = true;

    /* Bound on `root`, not on the wizard element: swapEditorial replaces the whole
       wizard subtree on a flavor/dose swap, which would take a listener bound to
       that node with it. Containment is checked per click instead. */
    root.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      /* Zmień on a completed chip → reopen that step. */
      var chip = target.closest('.aov-pdp-v3__chip');
      if (chip && chip.closest('[data-aov-wizard]')) {
        var cs = chip.closest('.aov-pdp-v3__wstep');
        if (cs) wizActivate(cs.getAttribute('data-aov-step'));
        return;
      }
      /* Selecting an option in the active step → complete + advance. Defer so
         wireVariantSwap's handler sets .is-active first (we read it for the chip). */
      var card = target.closest('.aov-pdp-v3__flavor-card, .aov-pdp-v3__dose-card, .aov-pdp-v3__duration-card');
      if (!card || !card.closest('[data-aov-wizard]')) return;
      if (card.getAttribute('aria-disabled') === 'true') return;
      var stepEl = card.closest('.aov-pdp-v3__wstep');
      var name = stepEl && stepEl.getAttribute('data-aov-step');
      /* First pick in a chooser → reveal its selected state from now on. */
      if (name === 'flavor') {
        var fl = root.querySelector('.aov-pdp-v3__flavors[data-aov-flavors-untouched]');
        if (fl) fl.removeAttribute('data-aov-flavors-untouched');
      } else if (name === 'dose') {
        var dz = root.querySelector('.aov-pdp-v3__doses[data-aov-doses-untouched]');
        if (dz) dz.removeAttribute('data-aov-doses-untouched');
      }
      if (name) setTimeout(function () { wizComplete(name); }, 0);
    });

    wizPrefill();
    wizRevealBuy();
    wizUpdateProgress();
  }

  function init() {
    wireProtokolAdd();
    wireVariantSwap();
    wirePromoFallback();
    wireWizard();
    bindSubmitOverride();
    applyActive();

    /* Catch a late VWO class flip + buy-button hydration with a BOUNDED poll.
       Deliberately NOT a MutationObserver: observing <html> while we relocate
       a <product-form> custom element re-enters (the move triggers theme
       scripts that toggle classes) and locks the tab. The poll is idempotent
       (relocate/injectGalleryTrust guard against re-running) and self-stops. */
    var ticks = 0;
    var interval = setInterval(function () {
      ticks++;
      applyActive();
      if (ticks >= 30) clearInterval(interval); /* stop after ~15s */
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
